import gql from 'graphql-tag';
import parseOrderMutation from './parseOrderMutation';
import orderNS from './constants/orderNS';
import { getUserId } from '../../localStorages';

export default data => {
  const newData = data;
  newData.userId = getUserId() || newData.userId || null;
  const dataCreate = parseOrderMutation(newData, orderNS);
  const modifyOrder = `modifyOrder(input: ${dataCreate})`;
  return gql`
  mutation {
    ${modifyOrder} {
      id
      type
      status
      reason
      accountId
      userId
      isPartialFulfillmentAllowed
      effectiveDate
      submittedDate
      initialTerm
      initialTermUnit
      renewalTerm
      renewalTermUnit
      trialTerm
      trialTermUnit
      services {
        index
        serviceType
        provisioningId
        action
        reason
        status
        bundleId
        packageId
        lines {
          index
          action
          status
          reason
          quantity
          priceOverride
          priceOffset
          discountPercent
          startDate
          endDate
          relativeStart
          relativeEnd
          relativeStartUnit
          relativeEndUnit
          priceOfferId
          discountOfferId
        }
      }
    }
  }
`;
};
